<template>
  <footer>
    <div class="text-center m-center mb-20">
      <div :key="index" v-for="(column, index) in getColumns(LANG.footer.green_box)">
        <a v-if="!column.is_empty" :href="column.uri">{{ column.text }}</a>
      </div>
    </div>
    <div class="copyright">
      <div class="m-center">
        <a v-for="(entry) in LANG.footer.black_box" :href="entry.uri">{{ entry.text }}
        </a>
       <!--  <a href="//www.fairvalue-calculator.com/j/shop/terms">{{ LANG.footer.black_box.terms }}</a>
        <a href="//www.fairvalue-calculator.com/j/shop/terms">{{ LANG.footer.black_box.terms }}</a>
        <a href="//www.fairvalue-calculator.com/j/privacy">{{ LANG.footer.black_box.privacy_policy }}</a>
        <a href="//www.fairvalue-calculator.com/sitemap/">{{ LANG.footer.black_box.sitemap }}</a> -->
        <br />
        Fairvalue-Calculator 2005 - {{ new Date().getFullYear() }} &copy; All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
import LANG from "../i18n/loader";

export default {
  data: (_) => {
    return {
      LANG,
    };
  },
  methods: {
    getColumns(elements) {
      const length = elements.length;
      const col_width = Math.floor(12 / length);
      const remainder = 12 - col_width * length;
      const padding = Math.floor(remainder / 2);
      const columns = [];
      if (padding) {
        columns.push({
          is_empty: true,
          class: "col-md-" + padding,
        });
      }
      elements.forEach((element) => {
        element.is_empty = false;
        element.class = "col-md-" + col_width;
        columns.push(element);
      });
      return columns;
    },
  },
};
</script>